import React, { useState } from "react";
import { Card, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { UserForm, UserList } from "./";
import { ManagementLayout } from "../shared";

interface UserManagementProps {
  reqData?: Record<string, never> | { organization_id: string };
  requestInfo?: {
    url: string;
    data?: Record<string, unknown>;
  };
}

export default function UserManagement({
  reqData = {},
  requestInfo = {
    url: "/retrieve-users/",
    data: {},
  },
}: UserManagementProps) {
  const [refresh, setRefresh] = useState(false);
  const { t } = useTranslation();

  return (
    <ManagementLayout
      dataComponent={
        <UserList
          requestInfo={{
            url: requestInfo.url,
            data: {
              ...requestInfo.data,
              ...reqData,
              refresh,
            },
          }}
        />
      }
      createComponent={
        <Card>
          <Title order={4}>
            {t("create")} {t("user_singular")}
          </Title>
          <UserForm
            reqData={{
              ...reqData,
            }}
            onSuccess={() => {
              setRefresh((value) => !value);
            }}
          />
        </Card>
      }
    />
  );
}
